import { Modal } from "antd";
import querystring from "querystring";
import moment from "moment";
import { cloneDeep } from "lodash";
import pathToRegexp from 'path-to-regexp'
import { ROLE_KEY } from "./consts";
import { routerRedux } from 'dva/router'
import queryString from 'query-string'
import CryptoJS from 'crypto-js'

/* eslint no-useless-escape:0 import/prefer-default-export:0 */
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

export function isUrl(path) {
  return reg.test(path);
}

/**
 * 确认对话框
 */
export function confirm({
  title = "提示",
  content = "",
  okText = "确认",
  cancelText = "取消",
} = {}) {
  return new Promise(resolve => {
    const modal = Modal.confirm({
      title,
      content,
      okText,
      cancelText,
      onOk: () => {
        modal.destroy();
        resolve();
      },
    });
  });
}

/**
 * 获取url上的query
 */
export function getUrlQuery(url = window.location.href.split("?")[1] || "") {
  return querystring.parse(url);
}

export function pad(val, length = 2) {
  let strVal = String(val);
  const len = strVal.length;

  if (len >= length) return strVal;

  for (let i = 0; i < length - len; i++) {
    strVal = "0" + strVal;
  }

  return strVal;
}

/**
 * 判断element的父元素中是否包含某class
 * @param dom 元素
 * @param className 样式类名
 */
export function domParentHasClass(dom, className) {
  let node = dom;

  while (node) {
    let klass = node.className;

    if (typeof klass !== "string") klass = "";

    if (node && klass.indexOf(className) > -1) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}


export function getMonthDays(date) {
  const firstDay = moment(date).startOf('month').format('YYYY-MM-DD');
  const dayCount = moment(date).daysInMonth();
  const dayList = []
  for (let i = 0; i < dayCount; i++) {
    const theDay = moment(firstDay).add(i, 'days')
    dayList.push(theDay)
  }
  return dayList
}

export function getMonthDaysStr(date) {
  const firstDay = moment(date).startOf('month').format('YYYY-MM-DD');
  const dayCount = moment(date).daysInMonth();
  const dayList = []
  for (let i = 0; i < dayCount; i++) {
    const theDay = moment(firstDay).add(i, 'days')
    dayList.push(theDay.format('YYYY-MM-DD'))
  }
  return dayList
}

export function checkUserPermission(currentUser, permission) {
  const currentRoleId = Number(window.localStorage.getItem(ROLE_KEY))
  const currentRole = (currentUser.rolePermissionVos || []).filter(_ => _.roleId === Number(currentRoleId))[0] || {}
  const buttonPermissions = (currentRole.permissions || []).filter(_ => _.type === 'BUTTON').map(_ => {
    return _.authTag
  })

  return buttonPermissions.includes(permission)
}

/**
 * 将一位数组转化为树状结构
 * @param   {array}     array     需要转化的数组.
 * @param   {string}    id        数组中对象唯一ID的别名.
 * @param   {string}    parentId       数组中对象的父ID的别名.
 * @param   {string}    children  数组对象中子集的别名.
 * @return  {array}    返回的树状结构.
 */
export function arrayToTree(
  array,
  id = 'id',
  parentId = 'pid',
  children = 'children'
) {
  const result = []
  const hash = {}
  const data = cloneDeep(array)

  data.forEach((item, index) => {
    hash[data[index][id]] = data[index]
  })

  data.forEach(item => {
    const hashParent = hash[item[parentId]]
    if (hashParent) {
      !hashParent[children] && (hashParent[children] = [])
      hashParent[children].push(item)
    } else {
      result.push(item)
    }
  })
  return result
}

export function pathMatchRegexp(regexp, pathname) {
  return pathToRegexp(regexp).exec(pathname)
}

export function os() {
  var ua = navigator.userAgent,
    up = navigator.platform,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    // isTablet = (/(?:iPad|PlayBook|Safari)/.test(ua) && /^((?!Windows).)*$/.test(ua)) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
    isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian;

  // alert(ua);
  return {
    isTablet: isTablet,
    isPhone: isPhone,
    isAndroid: isAndroid,
    isPc: isPc
  };
}


//下载文件
export const downloadExcel = (data, fileName) => {
  if (data && fileName) {
    let blob = new Blob([data], { type: `text/plain;charset=utf-8` });
    let a = document.createElement('a');
    // 创建下载的链接
    let href = window.URL.createObjectURL(blob);
    a.href = href;
    // 下载后文件名
    a.download = fileName;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}


//修改路径参数
export const updateUrlSearch = (dispatch, locationParam, newQuery) => {

  const { query, pathname } = locationParam
  dispatch(routerRedux.push({
    pathname,
    search: queryString.stringify({
      ...query,
      ...newQuery,
    }),
  }))
}

//字符串首字母大写
export const firstWordBig = (str) => {
  let strTemp = str.toLowerCase();
  strTemp = strTemp.substring(0, 1).toUpperCase() + strTemp.substring(1);
  return strTemp;
}

//返回开始结束日期
export const getStartAndEnd = (v) => {
  let startT = '';
  let endT = '';
  if (v === 'week') {
    startT = moment().weekday(0).format('YYYY-MM-DD');
    endT = moment().weekday(6).format('YYYY-MM-DD');
  } else if (v === 'lastweek') {
    startT = moment().weekday(-7).format('YYYY-MM-DD'); // 上个星期一
    endT = moment().weekday(-1).format('YYYY-MM-DD');
  } else if (v === 'lastmonth') {
    startT = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
    endT = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
  } else if (v === 'month') {
    startT = moment().startOf('month').format('YYYY-MM-DD');
    endT = moment().endOf('month').format('YYYY-MM-DD');
  } else if (v === 'all') {

  } else if (v === 'today') {
    startT = moment().format('YYYY-MM-DD');
    endT = moment().format('YYYY-MM-DD');
  } else if (v === 'yesterday') {
    startT = moment().subtract(1, 'days').format('YYYY-MM-DD');
    endT = moment().subtract(1, 'days').format('YYYY-MM-DD');
  }

  return [startT, endT]
}

const KEY = 'hangzhouanken123'

//加密
export const ENCRYPT = (text) => {
  var srcs = CryptoJS.enc.Utf8.parse(text);
  var encrypted = CryptoJS.AES.encrypt(srcs, CryptoJS.enc.Utf8.parse(KEY), { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

export const splitRangeByMonths = (startDateStr, endDateStr) => {
  const startDate = moment(startDateStr);
  const endDate = moment(endDateStr);
  const result = [];

  while (startDate.isSameOrBefore(endDate, 'day')) {
    const startOfMonth = startDate.clone().startOf('month');
    const endOfMonth = startDate.clone().endOf('month').isBefore(endDate) ? startDate.clone().endOf('month') : endDate.clone();

    result.push({ startAt: startOfMonth.format('YYYY-MM-DD'), endAt: endOfMonth.format('YYYY-MM-DD') });

    startDate.add(1, 'month');
  }

  return result;
}